import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { getAllSpendingProjectList, getToolCategoryList } from "../../Thunks/HeyTraderThunks";
import { ToolCategoryList } from "../../Types/HeyTraderTypes/Tools/ToolCategoryList";

interface ToolCategorySliceState {
    loader: boolean; // for refres pages and inital loadings
    toolCategories: ToolCategoryList[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ToolCategorySliceState = {
    loader: false,
    toolCategories: [],
    errorDisplay: '',

}

// set state valu for api response

const toolCategorySlice = createSlice ({
    name: 'toolCategories',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getToolCategoryList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getToolCategoryList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getToolCategoryList.fulfilled, (state, action: PayloadAction<ToolCategoryList[]>) => {
                    state.loader = false;
                    state.toolCategories = action.payload;
                  })
    }
})

export const {} = toolCategorySlice.actions
export default toolCategorySlice.reducer

